import { Injectable } from '@angular/core';
import { Actions, EffectNotification, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, ROUTER_REQUEST } from '@ngrx/router-store';
import { Observable } from 'rxjs';
import { exhaustMap, filter, map, takeUntil } from 'rxjs/operators';

type CompareFnOrSemanticRoute = ((semanticRoute: string) => boolean) | string;

// Вспомогательный сервис для ограничения работы эффектов ngrx на определенных роутах
// передать можно функцию сравнения или строку с semanticRoute
@Injectable({
  providedIn: 'root',
})
export class RunEffectsOnSemanticRouteService {
  constructor(private actions$: Actions) {}

  ngrxOnRunEffectsOnSemanticRoute(
    compareFnOrSemanticRoute: CompareFnOrSemanticRoute,
  ): (resolvedEffects$: Observable<EffectNotification>) => Observable<EffectNotification> {
    return (resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> => {
      return this.actionRouterEnter(compareFnOrSemanticRoute).pipe(
        filter((isMatchRoute) => isMatchRoute),
        exhaustMap(() =>
          resolvedEffects$.pipe(
            takeUntil(this.actionRouterLeave(compareFnOrSemanticRoute).pipe(filter((isMatchRoute) => isMatchRoute))),
          ),
        ),
      );
    };
  }

  private actionRouterEnter(compareFnOrSemanticRoute: CompareFnOrSemanticRoute): Observable<boolean> {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      map(
        ({
          payload: {
            routerState: { semanticRoute },
          },
        }) =>
          typeof compareFnOrSemanticRoute === 'function'
            ? compareFnOrSemanticRoute(semanticRoute)
            : semanticRoute === compareFnOrSemanticRoute,
      ),
    );
  }

  private actionRouterLeave(compareFnOrSemanticRoute: CompareFnOrSemanticRoute): Observable<boolean> {
    return this.actions$.pipe(
      ofType(ROUTER_REQUEST),
      map(
        ({
          payload: {
            routerState: { semanticRoute },
          },
        }) =>
          typeof compareFnOrSemanticRoute === 'function'
            ? compareFnOrSemanticRoute(semanticRoute)
            : semanticRoute === compareFnOrSemanticRoute,
      ),
    );
  }
}
